import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '@/lib/api';

const AuthCallback = ({ setUser }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = location.hash;
      if (!hash.includes('session_id=')) {
        navigate('/login');
        return;
      }

      const sessionId = hash.split('session_id=')[1]?.split('&')[0];
      if (!sessionId) {
        navigate('/login');
        return;
      }

      try {
        const response = await api.post('/auth/session', null, {
          headers: { 'X-Session-ID': sessionId }
        });

        // STEP 8-I-3A · session_token 을 localStorage 에 저장하여 모바일 실기기에서
        // 쿠키가 실리지 않아도 axios interceptor 가 Authorization 헤더로 인증 유지.
        try {
          const tok = response && response.data && response.data.session_token;
          if (tok) window.localStorage.setItem('session_token', tok);
        } catch (_) { /* ignore */ }

        setUser(response.data);
        navigate('/dashboard', { state: { user: response.data }, replace: true });
      } catch (error) {
        console.error('Auth failed:', error);
        navigate('/login');
      }
    };

    processAuth();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen bg-white dark:bg-[#0A0A0A] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FF3B30] mx-auto mb-4"></div>
        <p className="text-sm text-gray-600 dark:text-gray-400">인증 중...</p>
      </div>
    </div>
  );
};

export default AuthCallback;